export const MESSAGING_FEATURE_FLAG = 'rollout.clients.pov_messaging';
export const COMMAND_CENTER_FEATURE_FLAG = 'command_center';

export const PAGE_SIZE = 25;
export const MAX_SELECTED_CONVERSATIONS = 200;

// Icon names come from the shared frontage icomoon set (same icons the legacy inbox uses)
export const FOLDERS = [
  { name: 'inbox', routeName: 'inbox', icon: 'icon-Inbox_POV' },
  { name: 'attention', routeName: 'attention', icon: 'icon-x16-alert' },
  { name: 'follow_up', routeName: 'follow_up', icon: 'icon-Followup-16' },
  { name: 'sent', routeName: 'sent', icon: 'icon-Sent_16' },
  { name: 'archived', routeName: 'archive', icon: 'icon-totalusage-s' },
  { name: 'trash', routeName: 'trash', icon: 'icon-16trash' },
];

export const SOURCES_FOLDER_PREFIX = 'sources_';

// Folder-dependent visible bulk actions (parity with legacy inbox-layout.js.coffee folder_actions)
export const FOLDER_ACTIONS = {
  inbox: ['delete', 'send_lead', 'follow_up'],
  sent: ['follow_up'],
  attention: ['delete', 'send_lead', 'follow_up'],
  follow_up: ['delete', 'send_lead', 'cancel_follow_up'],
  archived: ['move_to_inbox', 'delete', 'send_lead', 'follow_up'],
  trash: ['move_to_inbox', 'send_lead'],
  sources: ['delete', 'send_lead', 'assign', 'follow_up'],
};

// Per-message-type row icons (parity with legacy conversation-row.js.coffee)
export const MESSAGE_TYPE_ICONS = {
  appointment: 'icon-Appointments',
  event: 'icon-Events',
  invoice: 'icon-Invoices',
  payment_request: 'icon-Payments',
  payment: 'icon-Payments',
  document: 'icon-Documents',
  message: 'icon-Message',
  announcement: 'icon-Campaigns',
  review: 'icon-Star',
  call: 'icon-Phone',
};

export const FORBIDDEN_PERMANENT_DELETE_COUNTRIES = ['France'];

// "New" header menu — fired through the existing quick-action bridge
// (setForceModalMode + fire-quick-action postMessage; Angular opens the dialog in modal mode).
// Names match app/assets/frontage/app/utils/quick-actions-service.js.coffee handlers.
export const NEW_ACTIONS = [
  { name: 'message', labelKey: 'messaging.new_menu.message' },
  { name: 'appointment', labelKey: 'messaging.new_menu.appointment' },
  { name: 'client', labelKey: 'messaging.new_menu.client' },
  { name: 'invoice', labelKey: 'messaging.new_menu.invoice', feature: 'payments_module' },
  { name: 'estimate', labelKey: 'messaging.new_menu.estimate', feature: 'payments_module' },
  { name: 'record_payment', labelKey: 'messaging.new_menu.record_payment', feature: 'payments_module' },
  { name: 'document', labelKey: 'messaging.new_menu.document' },
  { name: 'announcement', labelKey: 'messaging.new_menu.announcement' },
];

export const PANE_IFRAME_ID = 'vue_pane_iframe';
